<div class="dialog-wrapper access-content">
	<h1 mat-dialog-title>{{ 'app.content_blocked.title' | translate }}</h1>
	<div mat-dialog-content>
		{{ data.message }}
	</div>
	<div mat-dialog-actions>
		<button type="button" class="btn primary" mat-dialog-close cdkFocusInitial (click)="watchTrailer()" *ngIf="hasTrailer">
			<span class="button-text">Bekijk trailer</span>

			<span class="button-icon">
				<fa-icon matSuffix [icon]="['fas', 'play']"></fa-icon>
			</span>
		</button>

		<button type="button" class="btn primary" mat-dialog-close cdkFocusInitial (click)="navigateSubscribe()">
			<span class="button-text">{{ 'app.become_member' | translate }}</span>

			<span class="button-icon">
				<fa-icon matSuffix [icon]="['fas', 'arrow-right-long']"></fa-icon>
			</span>
		</button>		
	</div>

	<button mat-icon-button class="close-dialog" [mat-dialog-close]="true">
		<fa-icon class="close-icon" matSuffix [icon]="['fas', 'times']"></fa-icon>
	</button>

	<div class="already">{{ 'app.existing_account_available' | translate }} <a class="login-link"
			(click)="goToLogin()">{{ 'app.login' | translate }}</a></div>
</div>